import {ReactNode} from 'react';
import throttle from 'lodash/throttle';
import {useEffect, useRef, useState} from 'react';

import './styles.css';

type Props = {height: number, width: number}

export const SizeContent = ({children}: {children: ({height, width}: Props) => ReactNode}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [{height, width}, setDimensions] = useState({height: 0, width: 0});

  const update = throttle(() => {
    const currentContainer = containerRef?.current;
    if (currentContainer) {
      const {height, width} = currentContainer.getBoundingClientRect();
      setDimensions({height, width});
    }
  }, 100);

  useEffect(() => {
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return (
    <div ref={containerRef} className="SizeContent">
      {height && width ? (children({height, width})) : null}
    </div>
  );
};

